import React, { useState } from 'react'
import RealtyDetails from '../../../../components/Realty/Details'
import { useParams, useHistory } from 'react-router-dom'
import { Fetch } from '@polvo-labs/react-auth'
import RealtyType from '../../../../models/Realty'
import Loader from '../../../../components/Loader'
import PageHeader from '../../PageHeader'
import PageContent from '../../PageContent'
import Button from '../../../../components/Button'
import routes from '../../../../config/routes'

interface Props {

}

const RealtyDetailsScreen: React.FC<Props> = () => {
  const params = useParams<{ id: string }>()
  const [key, setKey] = useState(0)
  const history = useHistory()
  return (
    <div>
      <PageHeader
        title="Imóvel"
        subtitle={`Detalhes do imóvel #${params.id}`}
        side={
          <Button
            label="Listar imóvel"
            backgroundColor="darkBlue"
            fontColor="white"
            borderColor="lightGray"
            small
            onClick={() => {
              history.push(routes.admin.realty.index.path)
            }}
          />
        }
      />
      <PageContent>
        <Fetch
          key={key}
          url={`${process.env.REACT_APP_API_URL}/realties/${params.id}`}
          loader={() => (
            <Loader
              darkMode
            />
          )}
        >
          {({ data }) => data && data.data && (
            <RealtyDetails
              realty={data.data as RealtyType}
              onUpdated={() => setKey(prev => prev + 1)}
              adminMode
            />
          )}
        </Fetch>
      </PageContent>
    </div>
  )
}

export default RealtyDetailsScreen
